import { SortOption } from './types'

export const DEAL_OVERVIEW = 'Overview';
export const BACK_OF_ENVELOPE = 'Back-Of-Envelope';
export const DEAL_ACTIVITY = 'Activity';

export const DEAL_OVERVIEW_TABS = [DEAL_OVERVIEW, BACK_OF_ENVELOPE, DEAL_ACTIVITY];

export const TAB_TO_SLUG: Record<string, string> = {
    [DEAL_OVERVIEW]: 'overview',
    [BACK_OF_ENVELOPE]: 'backofenvelope',
    [DEAL_ACTIVITY]: 'activity',
};

export const DEAL_DASHBOARD_TAB_SLUGS = new Set(Object.values(TAB_TO_SLUG));

export const SLUG_TO_TAB: Record<string, string> = {
    overview: DEAL_OVERVIEW,
    backofenvelope: BACK_OF_ENVELOPE,
    activity: DEAL_ACTIVITY,
};

 
export enum ExportOptions {
    DEAL_OVERVIEW = 'Deal overview',
    SCENARIO_DASHBOARD = 'Back-of-envelope',
}

export const CRM_ENTITY_TYPE = {
    CONTACT: 'contact',
    COMPANY: 'company',
    ACTIVITY: 'activity',
    PROJECT: 'project',
    DEAL: 'deal',
} as const;

export const projectIconFallback = 'default_project_picture_icons/1_256.png' as const;
export const ACTIVITY_TYPE = {
    MEETING: 'Meeting',
    EMAIL: 'Email',
    NOTE: 'Note',
} as const;

export const DETAILS_TAB = 'details';
export const COMMENTS_TAB = 'comments';
export const ATTACHMENTS_TAB = 'attachments';

export const DUE_DILLIGENCE_TIMELINE_SLIDEOUT_TABS = [DETAILS_TAB, COMMENTS_TAB, ATTACHMENTS_TAB];

export const SORT_OPTIONS = [
    { value: 'newest' as SortOption, label: 'Newest first' },
    { value: 'oldest' as SortOption, label: 'Oldest first' },
];